import React from "react";
import {
  Container,
  FlexRowWrapper,
  FlexWrapper,
  Text2,
  Text3,
  Text4,
  Text4_5,
  Text5,
  Text6,
} from "../../Components/Common";
import Navbar from "../../Components/Navbar/Navbar";
import { Heading } from "../../Components/Template/Templete1/style";
import {
  BackgroundImageWrapper,
  CardWrapper,
  HeroSectionWrapper,
  MainWrapper,
  MoneyImageLogo,
} from "./styles";
import ClockImage from "../../Assets/clock.png";
import TrendingUpImage from "../../Assets/trending_up.png";
import FileWriteImage from "../../Assets/file_rename.png";
import {
  StarterCard,
  BossModeCard,
  ProCard,
} from "../../Components/Cards/PriceCards/index";
import {
  ExpandIcon,
  FAQPoints,
  ShopifyImage,
  ShopifyImageWrapper,
} from "../Home/Sections/SectionThree/style";
import DownArrow from "../../Assets/down-arrow.png";
import ShopifyImageImage from "../../Assets/shopify.png";
import TempeleteOne from "../../Components/Template/Templete1";
import MoneybackImage from "../../Assets/money-back.png";
import Footer from "../../Components/Footer/Footer";
import Switch from "../../Components/Switch/Switch";
import CustomGrid from "../../Components/CustomGrid";
import ScrollAnimation from "react-animate-on-scroll";

const Pricing = () => {
  return (
    <>
      <Navbar />
      <MainWrapper>
        {/* hero section */}
        <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
          <HeroSectionWrapper>
            <Container
              width={"95%"}
              margin={"160px auto 40px auto"}
              mobileMargin={"10px auto 0px auto"}
            >
              <FlexWrapper
                direction={"column"}
                justify={"center"}
                align={"center"}
              >
                <Heading weight={900} fontFamily={"Inter"}>
                  The Easiest Way To Write Great
                  <br /> Copy, Fast
                </Heading>
                <FlexWrapper
                  width={"80%"}
                  justify={"space-around"}
                  margin={"30px auto"}
                  gap={"30px"}
                >
                  <CardWrapper>
                    <img src={FileWriteImage} />
                    <Text6 color={"white"}>END WRITER'S BLOCK FOREVER</Text6>
                  </CardWrapper>
                  <CardWrapper>
                    <img src={ClockImage} />
                    <Text6 color={"white"}>PUBLISH MORE CONTENT FASTER</Text6>
                  </CardWrapper>
                  <CardWrapper>
                    <img src={TrendingUpImage} />
                    <Text6 color={"white"}>BOOST SALES WITH BETTER COPY</Text6>
                  </CardWrapper>
                </FlexWrapper>
                <Switch />
              </FlexWrapper>
              <Container width={"100%"} margin={"100px auto"}>
                <FlexWrapper
                  justify={"space-around"}
                  wrap={"wrap"}
                  gap={"40px"}
                >
                  <ScrollAnimation
                    animateIn="fadeIn"
                    duration={1.5}
                    delay={100}
                  >
                    <StarterCard />
                  </ScrollAnimation>
                  <ScrollAnimation
                    animateIn="fadeIn"
                    duration={1.5}
                    delay={100}
                  >
                    <ProCard />
                  </ScrollAnimation>
                  <ScrollAnimation
                    animateIn="fadeIn"
                    duration={1.5}
                    delay={100}
                  >
                    <BossModeCard />
                  </ScrollAnimation>
                </FlexWrapper>
              </Container>
            </Container>
          </HeroSectionWrapper>
        </ScrollAnimation>

        <Container>
          <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
            <FlexWrapper
              direction={"column"}
              margin={"40px auto"}
              mobileMargin={"5px auto"}
            >
              <Text4_5 color={"white"} weight={700}>
                {
                  "Each plan is subject to our fair use policy and its respective platform limits."
                }
              </Text4_5>
              <FlexWrapper
                margin={"50px auto"}
                gap={"0px"}
                mobileMargin={"10px auto"}
              >
                <MoneyImageLogo src={MoneybackImage} />
                <Container padding={"0px"} width={"70%"}>
                  <FlexWrapper direction={"column"}>
                    <Text3
                      color={"white"}
                      weight={800}
                      align={"left"}
                      margin={"10px 0px"}
                    >
                      7 day money back guarantee
                    </Text3>
                    <Text4_5
                      color={"white"}
                      margin={"10px 0px"}
                      align={"left"}
                      weight={600}
                    >
                      Our 7-day money back guarantee is designed for all those
                      who are <br /> unsure about their decision. We know life
                      can be unpredictable, and <br /> sometimes people change
                      their minds. Our pledge is simple: If for <br /> some
                      reason our product doesn't work out or you don't like it –
                      we <br />
                      will completely refund your subscription costs in full
                      within 7 days of <br />
                      signing up and up to 20,000 words used without hassle.
                    </Text4_5>
                  </FlexWrapper>
                </Container>
              </FlexWrapper>
            </FlexWrapper>
          </ScrollAnimation>
          {/* FAQ section */}
          <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
            <FlexWrapper direction={"column"} margin={"30px auto"}>
              <Text2
                color={"white"}
                weight={900}
                margin={"30px auto"}
                fontFamily={"Inter"}
              >
                FAQ
              </Text2>
              <FlexWrapper wrap={"wrap"} gap={"30px"} justify={"space-between"}>
                <FAQPoints width={"45%"}>
                  <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                    What's the cost of Escribelo?
                  </Text4_5>
                  <ExpandIcon src={DownArrow} />
                </FAQPoints>
                <FAQPoints width={"45%"}>
                  <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                    What's the cost of Escribelo?
                  </Text4_5>
                  <ExpandIcon src={DownArrow} />
                </FAQPoints>
                <FAQPoints width={"45%"}>
                  <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                    What examples I can use Escribelo for?
                  </Text4_5>
                  <ExpandIcon src={DownArrow} />
                </FAQPoints>
                <FAQPoints width={"45%"}>
                  <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                    What examples I can use Escribelo for?
                  </Text4_5>
                  <ExpandIcon src={DownArrow} />
                </FAQPoints>
                <FAQPoints width={"45%"}>
                  <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                    What's the cost of Escribelo?
                  </Text4_5>
                  <ExpandIcon src={DownArrow} />
                </FAQPoints>
                <FAQPoints width={"45%"}>
                  <Text4_5 color={"white"} margin={"0px 5px 0px 0px"}>
                    What's the cost of Escribelo?
                  </Text4_5>
                  <ExpandIcon src={DownArrow} />
                </FAQPoints>
              </FlexWrapper>
            </FlexWrapper>
          </ScrollAnimation>
          {/* OUR Mission section */}
        </Container>
        <BackgroundImageWrapper>
          <Container>
            <Container margin={"70px  auto"} mobileMargin={"20px auto"}>
              <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
                <FlexWrapper direction={"column"} margin={"40px auto"}>
                  <Text3 color={"white"} weight={900} fontFamily={"Inter"}>
                    Read Over 100+ reviews that rated Escribelo <br /> 4.9/5
                    stars
                  </Text3>
                  <Text5 color={"white"} weight={700}>
                    Our mission is to help people break through writer's block
                    to finally <br /> get their content done! We can't wait to
                    see what you create with <br /> your AI assistant
                  </Text5>

                  <FlexRowWrapper
                    wrap={"wrap"}
                    justify={"space-around"}
                    margin={"30px auto 5px auto"}
                  >
                    {Array.from(Array(8).keys()).map((item, index) => (
                      <ShopifyImageWrapper key={index}>
                        <ShopifyImage src={ShopifyImageImage} />
                      </ShopifyImageWrapper>
                    ))}
                  </FlexRowWrapper>
                </FlexWrapper>
              </ScrollAnimation>
            </Container>
          </Container>
          <ScrollAnimation animateIn="fadeIn" duration={1.5} delay={100}>
            <Container>
              <CustomGrid />
            </Container>
          </ScrollAnimation>
          <ScrollAnimation animateIn="fadeIn" duration={1} delay={100}>
            <Container margin={"0px auto"} padding={'0px 0px 40px 0px'}>
              <TempeleteOne
                heading1={"Save Hours Every Week Writing Long-"}
                heading2={"Form Content With Jarvis."}
                description={
                  "Stop spending so much time writing blog articles, social media posts, and sales emails..."
                }
                description2={" let Escribelo write for you."}
                ButtonTitle={"Go pro unlimited"}
              />
            </Container>
          </ScrollAnimation>
        </BackgroundImageWrapper>

        <Footer />
      </MainWrapper>
    </>
  );
};

export default Pricing;
